<template>
  <div class="product-grid">
    <PartsProductCard
      v-for="productContent in productContents"
      :key="productContent.productCode"
      :product-content="productContent"
    />
  </div>
</template>

<script setup lang="ts">
/**
 * 支給デザインの `product-grid`（`product-card` の4カラムグリッド。SP は2カラム）。
 * 支給6本・81箇所に出るのでトップ専用にせず commons に置く。
 *
 * 絞り込みは呼び出し側の `computed` で済ませ、ここには渡された分だけ描画する。
 * 支給JSは全件をDOMに置いて `is-hidden` で隠す方式だが、その `is-hidden` は使わない。
 */
import type { ProductContent } from '@/types/domains/ProductContentType';

type Props = {
  productContents: ProductContent[];
};
defineProps<Props>();
</script>
